import { WhereAreWePageFetchedData } from "@/Types/FetchedDataTypes"
import React, { SetStateAction } from "react"
import { toast } from "sonner"

interface ComponentProps {
  clinic: WhereAreWePageFetchedData
  setFocusedClinic: React.Dispatch<SetStateAction<{ lat: number, lng: number } | undefined>>,
  setZoom: React.Dispatch<SetStateAction<number | null>>,
  focusedClinic: { lat: number, lng: number } | undefined
}



export default function AddressCard({ setFocusedClinic, setZoom, focusedClinic, clinic }: ComponentProps) {

  function chooseLocation() {
    if(!clinic.location){
      return
    }
    setFocusedClinic(clinic.location)
    setZoom(20)
  }



  return (
    <div onClick={() => chooseLocation()} className={`w-full rounded-xl border border-gray-400 bg-white p-4 shadow-md mb-4 cursor-pointer hover:bg-gray-200 duration-150 ${clinic.location === focusedClinic && "border-pink-bg"}`}>

      <h2 className="text-lg font-semibold text-gray-800 mb-2">
        {clinic.hospitalName}
      </h2>


      <p className="text-sm text-gray-600 mb-2">
        📍 {clinic.address}
      </p>

      {clinic.doctorName &&
        <p className="text-sm text-gray-600">
          👨‍⚕️ {clinic.doctorName}
        </p>
      }

      <p className="text-sm text-gray-600">
        📞 {clinic.phoneNumber}
      </p>

    </div>
  );
}